import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { TariffUpdateError, HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idPrice: number;
  endDate: string;
  amount: number;
};

export const updatePrice = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('updatePrice'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    if (response.status === 400) {
      throw new TariffUpdateError();
    }

    throw new HTTPResponseError(response);
  }
};
